/**
 * Qatar Oil and Gas - PDF Presentation Configuration (Arabic)
 *
 * Arabic translation of slide-by-slide configuration with narrations for avatar TTS.
 */

export const qatarOilGasPresentation = {
  pdfUrl: 'https://storage.googleapis.com/qudemo-test-qudemo/licensed-image.pdf',

  slides: [
    {
      page: 1,
      title: 'تنمية النفط والغاز',
      narration: `تمثل هذه الصورة تحول قطر من خلال النفط والغاز.   غيّر اكتشاف هذه الموارد قطر من أمة صغيرة لصيد اللؤلؤ   إلى إحدى أغنى دول العالم.`,
    },
  ],
};

export default qatarOilGasPresentation;
